import { createRouter, createWebHistory } from 'vue-router'
import store from '../store/index'

import Login from 'ROUTER/modules/login.js'
import Catalogues from 'ROUTER/modules/catalogues.js'
import Reports from 'ROUTER/modules/reports.js'
import Clients from 'ROUTER/modules/clients.js'
import Points from 'ROUTER/modules/points'
import CustomerService from 'ROUTER/modules/customerservice.js'
// import Products from '@/views/catalogues/Products.vue'

// Heishop
import Heishop from 'ROUTER/modules/heishop/index.js'
// Supervision
import Supervision from 'ROUTER/modules/supervision/index.js'


const routes = [
    ...Login,
    ...Catalogues,
    ...Reports,
    ...Clients,
    ...Points,
    ...CustomerService,
    
    // Heishop
    ...Heishop,

    // // Supervision
    // ...Supervision,

    {
        path: '/:pathMatch(.*)*',
        component: () => import(/* webpackChunkName: "about" */ 'COMPONENTS/Page404.vue')
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

router.beforeEach((to, from, next) => {
    const session = store.getters['getSession']
  
    if(session == null && to.name !== 'login') {
        next({
            name: 'login'
        })
    }

    else if(session !== null && to.name == 'login') {
        // next(false)
        next({
            name: 'sales'
        })
    }

    else {
        next()
    }

})

export default router
